import { IContentDividerTemplate } from '@dadohr/shared/domainTypes/experience';
import { TaskBuilderContext } from '../../../types';

export const BlockSettingsContentDivider = ({
  value,
  expTpl
}: {
  value: IContentDividerTemplate;
  expTpl: TaskBuilderContext;
}) => {
  return <>No settings available for this block</>;
};

export const BlockSettingsContentDividerReadOnly = ({
  value
}: {
  value: IContentDividerTemplate;
}) => null;
